import createAxiosInstance from "../../app/helpers/tokenManager";

const erpApiInstance = createAxiosInstance(process.env.REACT_APP_ERP_API_URL);

export default erpApiInstance;
